module.exports = require("@swa-ui/currency");